import { UI_ORDER_TYPES_LIST } from '@velocity-exchange/common';

export const BLUR_OVERLAY_SIBLING_CLASSES = 'relative z-10';

export const PERP_ORDER_TYPE_OPTIONS = UI_ORDER_TYPES_LIST.filter(
	(orderType) => orderType.value !== 'oracle'
);

export const SPOT_ORDER_TYPE_OPTIONS = UI_ORDER_TYPES_LIST.filter(
	(orderType) =>
		orderType.value !== 'oracle' && orderType.value !== 'scaledOrders'
);

export const PRICE_FALLBACK_DISPLAY_VALUE = 'None';
